<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20">
        <div>
          <el-divider style="font-size: 16px;">
            <div style="font-size: 16px;"><span style="color: red;">3步</span>制作表格</div>
          </el-divider>
        </div>
        <div style="padding: 10px;">

          <el-form ref="editForm" :model="editForm" :rules="form_rules" size="mini">
            <div style="margin-left: 5px;">
              <div style="font-size: 16px;font-weight: bold;"><span style="color: red;">*</span><span
                  style="color: red;">第1步:</span>填写表格名称</div>
              <el-form-item :required="true">
                <el-input v-model="editForm.form_name" style="width: 50%;font-size: 16px;margin-top: 10px;"
                  placeholder="这里填写表格名称"></el-input>
              </el-form-item>
              <div style="font-size: 16px;font-weight: bold;"><span style="color: red;">*</span><span
                  style="color: red;">第2步:</span>选择填写张数</div>
              <el-form-item :required="true" style="margin-top: 10px;">
                <el-radio-group v-model="editForm.input_pages" size="medium">
                  <el-radio border label="1">每人只限填写一张</el-radio>
                  <el-radio border label="9999">不受填写张数限制,每人可填写多张</el-radio>
                </el-radio-group>
              </el-form-item>
              <div style="font-size: 16px;">填写说明(选填)</div>
              <el-form-item>
                <el-input type="textarea" :rows="2" style="width: 50%;font-size: 16px;margin-top: 10px;"
                  v-model="editForm.comment" placeholder="填表说明会在填表时会以弹出窗口的方式显示">
                </el-input>
              </el-form-item>
            </div>
            <div style="font-size: 16px;font-weight: bold;"><span style="color: red;">*</span><span
                style="color: red;">第3步:</span>添加表格的数据列</div>
            <div style="margin: 15px;">
              <div style="display: flex;justify-content: flex-start;">
                <!-- <div>增加表格数据列</div> -->
                <el-button type="primary" @click="showAddColumnDialog()"> +添加数据列</el-button>
              </div>
              <el-table ref="column_form" :data="columnData" stripe style="width: 100%">
                <el-table-column prop="column_name" label="数据列名" width="500">
                </el-table-column>
                <el-table-column prop="column_type" label="数据格式" width="150">
                </el-table-column>
                <el-table-column prop="column_optional" label="是否必填" width="150">
                  <template slot-scope="scope">
                    <div style="" v-if="scope.row.column_optional === '1'">可填可不填</div>
                    <div style="color: red;" v-else>必须填写</div>
                  </template>
                </el-table-column>
                <el-table-column prop="column_comment" label="填写说明">
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="200">
                  <template slot-scope="scope">
                    <!--     <el-button type="text" size="small" @click="moveUp(scope.$index)">上移</el-button>
                    <el-button type="text" size="small" @click="moveDown(scope.$index)">下移</el-button> -->
                    <el-button @click="deleteClick(scope.$index)" type="text" size="small">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div style="display: flex;justify-content: flex-end;margin: 20px;">共{{columnData.length}}行</div>
            </div>

            <el-form-item size="large" style="display: flex;justify-content: center;">
              <el-button type="primary" @click="saveForm()">保存并完成制作</el-button>
              <el-button @click="back">返回</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-col>
    </el-row>

    <!--表格名称-->
    <el-dialog width="40%" :close-on-click-modal="false" title="请添加数据列" :visible.sync="addColumnDialogVisible">
      <el-form ref="columnForm" label-width="80px" size="mini">
        <div>
          <el-form-item label="数据列名" :required="true">
            <el-input v-model="column_name" placeholder="这里填写数据列名称,如:姓名,电话等"></el-input>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="数据格式" :required="true">
            <el-select v-model="column_type" placeholder="请选择" @change="selectColumnType">
              <el-option v-for="item in columnTypes" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="是否必填" :required="true">
            <el-radio-group v-model="column_optional" size="medium">
              <el-radio border label="0">必须填写</el-radio>
              <el-radio border label="1">可填可不填</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="填写说明">
            <el-input type="textarea" :rows="2" v-model="column_comment" placeholder="填写说明"></el-input>
          </el-form-item>
        </div>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="addColumnDialogVisible=false">取 消</el-button>
        <el-button type="primary" @click="saveColumn()">添 加</el-button>
      </div>

    </el-dialog>

    <!--粘贴输入-->
    <el-dialog width="40%" :close-on-click-modal="false" title="添加选项" :visible.sync="addOptionsDialogVisible">
      <el-form ref="columnForm" label-width="80px" size="mini">
        <div>
          <el-form-item label="选项">
            <el-input type="textarea" :rows="5" v-model="option_list_str" placeholder="输入备选项,一行一个"></el-input>
          </el-form-item>
        </div>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelOptionsToColumn">取 消</el-button>
        <el-button type="primary" @click="addOptionsToColumn">添 加</el-button>
      </div>

    </el-dialog>

  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'

  export default {
    components: {
      MenuList,
      Header
    },
    created() {
      this.username = this.$session.get('USERNAME') // 获取session
    },
    data() {
      return {
        username: '',
        editForm: {
          id: '',
          form_name: '',
          form_comment: '',
          input_pages: 0
        },
        form_rules: {
          form_name: [{
            required: true,
            message: '请输入',
            trigger: 'blur'
          }]
        },

        columnData: [],
        addColumnDialogVisible: false,

        column_name: '',
        column_type: '',
        column_comment: '',
        column_options: [],
        column_optional: '',
        column_field_sample: '',

        columnTypes: [{
            label: '任意内容(无固定格式)',
            value: '文本'
          }, {
            label: '数字(只能填数字)',
            value: '数字'
          },
          {
            label: '日期(格式:年-月-日)',
            value: '日期'
          },
          {
            label: '日期及时间(格式:年-月-日 时:分)',
            value: '日期时间'
          },
          {
            label: '自动时间(无需填写,系统自动填写填表时间)',
            value: '自动时间'
          },
          {
            label: '单选(多个选项中选一个)',
            value: '单选'
          },
          {
            label: '多选(多个选项中可选多个)',
            value: '多选'
          },
          {
            label: '图片(上传一张图片)',
            value: '图片'
          },
          {
            label: '视频(上传一个视频)',
            value: '视频'
          },
          {
            label: '位置(自动上报填表人位置)',
            value: '定位'
          },
          {
            label: '身份证号(只能填写身份证号)',
            value: '身份证号'
          },
          {
            label: '手机号(只能填写手机号)',
            value: '手机号'
          },
          {
            label: 'Email邮箱(只能填写邮箱)',
            value: 'Email邮箱'
          }
        ],

        addOptionsDialogVisible: false,
        option_list_str: ''
      }
    },
    methods: {
      back() {
        this.$router.go(-1)
      },

      showAddColumnDialog() {
        this.column_name = ''
        this.column_type = ''
        this.column_comment = ''
        this.column_options = []
        this.column_optional = ''
        this.column_field_sample = ''

        this.addColumnDialogVisible = true
      },
      saveColumn() {
        if (this.column_name === '') {
          this.$message.error('请输入列名!')
          return
        }

        if (this.isExistColumn(this.column_name)) {
          this.$message.error('"' + this.column_name + '"列已存在,请更换列名称!')
          return
        }

        if (this.column_type === '') {
          this.$message.error('请选择数据类型!')
          return
        }

        if (this.column_optional === '') {
          this.$message.error('请确认是否必须填写!')
          return
        }

        let column = {
          column_name: this.column_name,
          column_type: this.column_type,
          column_optional: this.column_optional,
          column_comment: this.column_comment,
          column_options: this.column_options,
          column_field_sample: this.column_field_sample
        }

        this.columnData.push(column)

        this.addColumnDialogVisible = false
        this.$message({
          message: '"' + this.column_name + '"添加成功!',
          type: 'success'
        })
      },
      isExistColumn(column_name) {
        // 列是否存在
        if (this.columnData.length === 0) return false
        for (var i = 0; i < this.columnData.length; i++) {
          let tmpObj = this.columnData[i]
          if (tmpObj.column_name === column_name) {
            return true
          }
        }

        return false
      },
      deleteClick(index) {
        var colName = this.columnData[index].column_name

        let that = this
        that.$confirm('确定要删除"' + colName + '"吗?', '操作提示', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let tmpColumnArray = []

          for (var i = 0; i < that.columnData.length; i++) {
            if (i !== index) {
              tmpColumnArray.push(that.columnData[i])
            }
          }

          that.columnData = []
          that.columnData = tmpColumnArray
        }).catch(() => {

        })
      },
      saveForm() {
        // 校验数据
        if (this.editForm.form_name === '') {
          this.$message.error('请输入表格名称')
          return
        }

        // 校验数据
        if (this.editForm.input_pages === 0) {
          this.$message.error('请选择填表张数')
          return
        }

        if (this.columnData.length === 0) {
          this.$message.error('请添加表格数据列')
          this.addColumnDialogVisible = true
          return
        }

        let that = this

        let data = {
          username: this.username,
          form_name: this.editForm.form_name,
          form_comment: this.editForm.form_comment,
          form_input_pages: this.editForm.input_pages,
          form_columns: JSON.stringify(that.columnData)
        }

        var qs = require('qs')

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/form/web/_save_form.jsp'

        this.axios.post(
            requestUrl,
            qs.stringify(data), {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            }
          ).then(function(response) {
            that.$router.push('/form_list')
            load.close()
            that.$message.success('制表成功！')
          })
          .catch(function() {
            load.close()
            that.$router.push('/form_list')
          })
      },
      convertOptional(scope) {
        // console.log(scope.row.column_optional)
        if (scope.row.column_optional === '1') {
          return '可填可不填'
        } else {
          return '必须填写'
        }
      },
      moveUp(index) {
        if (index === 0) {
          this.$message({
            message: '已经是第一行了!',
            type: 'error'
          })
        }

        console.log(this.columnData)
        console.log(this.columnData[index - 1].column_name)
        console.log(this.columnData[index].column_name)

        let preObj = this.columnData[index - 1]
        this.columnData[index - 1] = this.columnData[index]
        this.columnData[index] = preObj

        console.log(this.columnData)

        this.$message({
          message: '移动成功!',
          type: 'success'
        })
      },
      moveDown(index) {
        if (index === this.columnData.length - 1) {
          this.$message({
            message: '已经是最后一行了!',
            type: 'error'
          })
        }

        // var newIndex = index + 1
      },
      selectColumnType() {
        if (this.column_type === '单选' || this.column_type === '多选') {
          this.addOptionsDialogVisible = true
        }
      },
      cancelOptionsToColumn() {
        this.column_type = ''
        this.addOptionsDialogVisible = false
      },
      addOptionsToColumn() {
        // 分解字符串
        let snsArr = this.option_list_str.split(/[(\r\n)\r\n]+/)

        if (snsArr.length === 0) {
          this.cancelOptionsToColumn()
          return
        }

        snsArr.forEach((item, index) => {
          if (!item) {
            snsArr.splice(index, 1) // 删除空项
          }
        })

        this.column_options = snsArr
        this.addOptionsDialogVisible = false
      }

    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/make_form.vue